import { createContext, useContext, useMemo } from 'react';
import { rsvpI18n } from './rsvp.i18n';
import { foodI18n } from './food.i18n';

const agendaI18n = {
    hu: {
        // ... other translations
        agenda: {
            title: 'Program',
            welcome: 'Vendégvárás, vendégek fogadása',
            ceremony: 'Hivatalos polgári szertartás',
            congratulations: 'Gratulációk, pezsgős koccintás',
            photos: 'kis- és nagycsoportos képek készítése',
            afterCeremony: 'a szertartás és a képek elkészítése után',
            creativePhotos: 'az ifjú pár kettesben lebonyolítja a kreatív fotózást',
            seating: 'a vendégek a vacsora kezdete előtt - a ceremóniamester segítségével - elfoglalják helyeiket',
            dinner: 'Vacsora',
            firstDance: 'Nyitótánc',
            cake: 'Torta',
            midnightSnack: 'Éjféli menü',
            party1: 'buli',
            party2: 'kifulladásig',
            breakfast: 'Reggeli szervírozása az üvegteremben',
            bbq: 'Barbeque party',
            church: 'Egyházi szertartás Debrecenben, a Szent Anna templomban',
            churchPlease: 'A katolikus templomi szertartás alatt, ha a választott ruházatuk ezt indokolja, kérjük, hogy takarják el vállukat egy kendővel vagy egyéb hasonló kiegészítővel.',
        }
    },
    en: {
        // ... other translations
        agenda: {
            title: 'Agenda',
            welcome: 'Guest reception',
            ceremony: 'Official civil ceremony',
            congratulations: 'Congratulations, champagne toast',
            photos: 'small and large group photos',
            afterCeremony: 'after the ceremony and photos',
            creativePhotos: 'the newlyweds will have a creative photoshoot',
            seating: 'guests will take their seats before dinner with the help of the master of ceremonies',
            dinner: 'Dinner',
            firstDance: 'First dance',
            cake: 'Cake',
            midnightSnack: 'Midnight snack',
            party1: 'party',
            party2: 'until exhaustion',
            breakfast: 'Breakfast served in the glass room',
            bbq: 'Barbeque party',
            church: 'Church ceremony at St. Anna Church, Debrecen',
            churchPlease: 'During the Catholic church ceremony, if your chosen outfit requires it, please cover your shoulders with a shawl or similar accessory.',
        }
    }
}

export const i18n = {
    'hu': {
        today: 'Ma!',
        menu: {
            root: 'Főoldal',
            countdown: 'Visszaszámláló',
            agenda: 'Menetrend'
        },
        month: 'Május',
        fullDate: '2025. május 31.',
        dowShort: ['H', 'K', 'SZ', 'CS', 'P', 'SZ', 'V'],
        events: [],
        countDownLabels: {
            years: 'év',
            months: 'hónap',
            weeks: 'hét',
            days: 'nap',
            hours: 'óra',
            minutes: 'perc',
            seconds: 'másodperc'
        },
        veryTop: {
            rsvp: 'Válaszolok',
            wgm: 'Összeházasodunk',
            rsvpToday: 'Menü'
        },
        bbq: {
            text: 'barbeque party'
        },
        secondStrip: {
            daysUntil: 'Még hátra van ...',
            daysPassed: 'Már eltelt ...'
        },
        timeline: {
            h2: 'Kapcsolatunk története',
            milestones: [
                'Első randik - 2017',
                'Első utazás - 2017',
                'Első közös USA - 2018',
                'Dead Sea - 2019',
                'Istambul - 2021',
                'Hárman - 2022',
                'Hala Madrid - 2023',
                '💍 - 2024'
            ]
        },
        dressCode: {
            black: 'Full Fekete Sikk',
            please: `Megkérünk minden kedves vendéget, hogy az esküvőre <strong style="font-size: 1.2em">teljes fekete</strong> öltözetben érkezzen`
        },
        location: {
            h2: 'HELYSZÍN',
            photo: 'Fotós',
            address: 'Biri, Fő utca 94, 4235', // '4235 Biri, Fő str. 94.',
            master: 'Ceremóniamester',
            masterText1: 'Ha bármilyen kérdésük van a nagy nappal kapcsolatban, ne habozzanak!',
            masterText2: '{{name}} készséggel áll rendelkezésükre.'
        },
        ...agendaI18n.hu,
        meta: {
            welcome: 'Szeretettel várunk!',
            instruction: 'Az alábbi gombra kattintva tudtok visszajelzést adni számunkra minden fontos részlettel kapcsolatban',
            rsvp: 'Válaszolok',
            by: 'by @szalontaijordan'
        },
        ...rsvpI18n.hu,
        food: { ...foodI18n.hu },
        plural: (noun, count) => noun,
    },
    'en': {
        today: 'Today!',
        menu: {
            root: 'Home',
            countdown: 'Countdown',
            agenda: 'Agenda'
        },
        month: 'May',
        fullDate: 'May 31, 2025',
        dowShort: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
        events: [],
        countDownLabels: {
            years: 'year',
            months: 'month',
            weeks: 'week',
            days: 'day',
            hours: 'hour',
            minutes: 'minute',
            seconds: 'second'
        },
        veryTop: {
            rsvp: 'RSVP',
            wgm: 'We’re getting married',
            rsvpToday: 'Menu'
        },
        bbq: {
            text: 'barbeque party'
        },
        secondStrip: {
            daysUntil: 'Let the countdown begin ...',
            daysPassed: 'Since ...'
        },
        timeline: {
            h2: 'Our Story',
            milestones: [
                'First dates - 2017',
                'First trip - 2017',
                'First USA trip - 2018',
                'Dead Sea - 2019',
                'Istanbul - 2021',
                'Three of us - 2022',
                'Hala Madrid - 2023',
                '💍 - 2024'
            ]
        },
        dressCode: {
            black: 'All Black Chic',
            please: `We kindly ask all guests to wear <strong style="font-size: 1.2em">all black</strong> attire to the wedding`
        },
        location: {
            h2: 'LOCATION',
            photo: 'Photographer',
            address: '4235 Biri, Fő str. 94.',
            master: 'Master of ceremonies',
            masterText1: 'If you have any questions about the big day, don’t hesitate!',
            masterText2: 'Feel free to contact {{name}} who will be happy to assist you.'
        },
        ...agendaI18n.en,
        meta: {
            welcome: 'We warmly welcome you!',
            instruction: 'Click the button below to provide feedback with all the important details',
            rsvp: 'RSVP',
            by: 'by @szalontaijordan'
        },
        ...rsvpI18n.en,
        food: { ...foodI18n.en },
        plural: (noun, count) => count === 1 ? noun : noun + 's',
    }
};

export const I18NContext = createContext({ lang: 'hu', setLang: () => {} });

export function useI18n() {
    const { lang } = useContext(I18NContext);
    return useMemo(() => i18n[lang], [lang]);
}
